{
  "HELP_CENTER": {
    "TITLE": "Κέντρο Βοήθειας",
    "NEW_PAGE": {
      "DESCRIPTION": "Δημιουργήστε πύλες κέντρου βοήθειας αυτοεξυπηρέτησης για τους πελάτες σας. Βοηθήστε τους να βρίσκουν γρήγορα απαντήσεις, χωρίς αναμονή. Απλοποιήστε τα ερωτήματα, αυξήστε την αποδοτικότητα των πρακτόρων και αναβαθμίστε την υποστήριξη πελατών.",
      "CREATE_PORTAL_BUTTON": "Δημιουργία Πύλης"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Χωρίς τίτλο"
    },
    "HEADER": {
      "FILTER": "Φιλτράρισμα κατά",
      "SORT": "Ταξινόμηση κατά",
      "LOCALE": "Γλώσσα",
      "SETTINGS_BUTTON": "Ρυθμίσεις",
      "NEW_BUTTON": "Νέο Άρθρο",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Δημοσιευμένο",
        "DRAFT": "Draft",
        "ARCHIVED": "Αρχειοθετημένο"
      },
      "TITLES": {
        "ALL_ARTICLES": "Όλα Τα Άρθρα",
        "MINE": "Τα Άρθρα Μου",
        "DRAFT": "Draft Άρθρα",
        "ARCHIVED": "Αρχειοθετημένα Άρθρα"
      },
      "LOCALE_SELECT": {
        "TITLE": "Επιλογή γλώσσας",
        "PLACEHOLDER": "Επιλογή γλώσσας",
        "NO_RESULT": "Δεν βρέθηκε γλώσσα",
        "SEARCH_PLACEHOLDER": "Αναζήτηση γλώσσας"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Όλα Τα Άρθρα",
      "PUBLISH_BUTTON": "Δημοσίευση",
      "MOVE_TO_ARCHIVE_BUTTON": "Μετακίνηση στα αρχειοθετημένα",
      "PREVIEW": "Προεπισκόπηση",
      "ADD_TRANSLATION": "Προσθήκη μετάφρασης",
      "OPEN_SIDEBAR": "Άνοιγμα πλευρικής μπάρας",
      "CLOSE_SIDEBAR": "Κλείσιμο πλευρικής μπάρας",
      "SAVING": "Αποθηκεύεται...",
      "SAVED": "Αποθηκεύτηκε"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Ανέβασμα Εικόνας",
        "UPLOADING": "Ανέβασμα...",
        "SUCCESS": "Η εικόνα ανέβηκε με επιτυχία",
        "ERROR": "Σφάλμα κατά το ανέβασμα της εικόνας",
        "UN_AUTHORIZED_ERROR": "Δεν έχετε δικαίωμα να ανεβάσετε εικόνες",
        "ERROR_FILE_SIZE": "Το μέγεθος της εικόνας πρέπει να είναι μικρότερο από {size}MB",
        "ERROR_FILE_FORMAT": "Η μορφή της εικόνας πρέπει να είναι jpg, jpeg ή png",
        "ERROR_FILE_DIMENSIONS": "Οι διαστάσεις της εικόνας πρέπει να είναι μικρότερες από 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Εισαγωγή άγκυρας",
        "TITLE": "Εισαγωγή άγκυρας",
        "SUBMIT": "Εισαγωγή",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Ρυθμίσεις Άρθρου",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Κατηγορία",
          "TITLE": "Επιλογή κατηγορίας",
          "PLACEHOLDER": "Επιλογή κατηγορίας",
          "NO_RESULT": "Δεν βρέθηκε καμία κατηγορία",
          "SEARCH_PLACEHOLDER": "Αναζήτηση κατηγορίας"
        },
        "AUTHOR": {
          "LABEL": "Συγγραφέας",
          "TITLE": "Επιλογή συγγραφέα",
          "PLACEHOLDER": "Επιλογή συγγραφέα",
          "NO_RESULT": "Δεν βρέθηκαν συγγραφείς",
          "SEARCH_PLACEHOLDER": "Αναζήτηση συγγραφέα"
        },
        "META_TITLE": {
          "LABEL": "Μετα-τίτλος",
          "PLACEHOLDER": "Προσθήκη meta Τίτλου"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta περιγραφή",
          "PLACEHOLDER": "Προσθέστε τη meta περιγραφή σας για καλύτερα αποτελέσματα SEO..."
        },
        "META_TAGS": {
          "LABEL": "Meta tags",
          "PLACEHOLDER": "Προσθήκη μετα-ετικετών διαχωρισμένων με κόμμα..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Αρχειοθέτηση άρθρου",
        "DELETE": "Διαγραφή άρθρου"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Χωρίς κατηγορία",
      "SEARCH_RESULTS": "Αποτελέσματα αναζήτησης για {query}",
      "EMPTY_TEXT": "Αναζητήστε άρθρα για εισαγωγή σε απαντήσεις.",
      "SEARCH_LOADER": "Αναζήτηση...",
      "INSERT_ARTICLE": "Εισαγωγή",
      "NO_RESULT": "Δεν βρέθηκαν άρθρα",
      "COPY_LINK": "Αντιγραφή συνδέσμου άρθρου στο πρόχειρο",
      "OPEN_LINK": "Άνοιγμα άρθρου σε νέα καρτέλα",
      "PREVIEW_LINK": "Προεπισκόπηση άρθρου"
    },
    "PORTAL": {
      "HEADER": "Πύλες",
      "DEFAULT": "Προεπιλογή",
      "NEW_BUTTON": "Νέα Πύλη",
      "ACTIVE_BADGE": "ενεργή",
      "CHOOSE_LOCALE_LABEL": "Επιλέξτε μια γλώσσα",
      "LOADING_MESSAGE": "Φόρτωση πυλών...",
      "ARTICLES_LABEL": "άρθρα",
      "NO_PORTALS_MESSAGE": "Δεν υπάρχουν διαθέσιμες πύλες",
      "ADD_NEW_LOCALE": "Προσθέστε μια νέα γλώσσα",
      "POPOVER": {
        "TITLE": "Πύλες",
        "PORTAL_SETTINGS": "Ρυθμίσεις πύλης",
        "SUBTITLE": "Έχετε πολλαπλές πύλες με διαφορετικές γλώσσες για κάθε πύλη.",
        "CANCEL_BUTTON_LABEL": "Άκυρο",
        "CHOOSE_LOCALE_BUTTON": "Επιλέξτε γλώσσα"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "άρθρα",
            "ADD": "Προσθήκη γλώσσας",
            "VISIT": "Επίσκεψη site",
            "SETTINGS": "Ρυθμίσεις",
            "DELETE": "Διαγραφή"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Ρυθμίσεις Πύλης",
            "ITEMS": {
              "NAME": "Όνομα",
              "DOMAIN": "Προσαρμοσμένο Domain",
              "SLUG": "Slug",
              "TITLE": "Τίτλος πύλης",
              "THEME": "Χρώμα θέματος",
              "SUB_TEXT": "Υποκείμενο πύλης"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Διαθέσιμες γλώσσες",
            "TABLE": {
              "NAME": "Όνομα γλώσσας",
              "CODE": "Κωδικός γλώσσας",
              "ARTICLE_COUNT": "Αριθμός άρθρων",
              "CATEGORIES": "Αριθμός κατηγοριών",
              "SWAP": "Εναλλαγή",
              "DELETE": "Διαγραφή",
              "DEFAULT_LOCALE": "Προεπιλογή"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Διαγραφή πύλης",
          "MESSAGE": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την πύλη",
          "YES": "Ναι, διαγραφή πύλης",
          "NO": "Όχι, διατήρηση πύλης",
          "API": {
            "DELETE_SUCCESS": "Η πύλη διαγράφηκε επιτυχώς",
            "DELETE_ERROR": "Σφάλμα κατά τη διαγραφή της πύλης"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Επεξεργασία πύλης",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Βασικές πληροφορίες"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Προσαρμογή πύλης"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Κατηγορίες"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Γλώσσες"
          }
        },
        "CATEGORIES": {
          "TITLE": "Κατηγορίες στο",
          "NEW_CATEGORY": "Νέα κατηγορία",
          "TABLE": {
            "NAME": "Όνομα",
            "DESCRIPTION": "Περιγραφή",
            "LOCALE": "Γλώσσα",
            "ARTICLE_COUNT": "Αριθμός άρθρων",
            "ACTION_BUTTON": {
              "EDIT": "Επεξεργασία κατηγορίας",
              "DELETE": "Διαγραφή κατηγορίας"
            },
            "EMPTY_TEXT": "Δεν βρέθηκαν κατηγορίες"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Ενημέρωση βασικών ρυθμίσεων"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Πληροφορίες κέντρου βοήθειας",
            "BODY": "Βασικές πληροφορίες σχετικά με την πύλη"
          },
          "CUSTOMIZATION": {
            "TITLE": "Προσαρμογή του κέντρου βοήθειας",
            "BODY": "Προσαρμογή πύλης"
          },
          "FINISH": {
            "TITLE": "Έξοχα! 🎉",
            "BODY": "Είναι όλα έτοιμα!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Πίσω",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Δημιουργία Πύλης",
            "TITLE": "Πληροφορίες κέντρου βοήθειας",
            "CREATE_BASIC_SETTING_BUTTON": "Δημιουργία βασικών ρυθμίσεων πύλης"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Προσαρμογή πύλης",
            "TITLE": "Προσαρμογή του κέντρου βοήθειας",
            "UPDATE_PORTAL_BUTTON": "Ενημέρωση ρυθμίσεων πύλης"
          },
          "FINISH_PAGE": {
            "TITLE": "Έξοχα!🎉 Έχετε ρυθμιστεί!",
            "MESSAGE": "Τώρα μπορείτε να δείτε την πύλη που δημιουργήθηκε στη σελίδα με όλες τις πύλες.",
            "FINISH": "Μετάβαση στις πύλες"
          }
        },
        "LOGO": {
          "LABEL": "Λογότυπο",
          "UPLOAD_BUTTON": "Μεταφόρτωση λογότυπου",
          "HELP_TEXT": "Το λογότυπο θα εμφανιστεί στην κεφαλίδα της πύλης.",
          "IMAGE_UPLOAD_SUCCESS": "Το λογότυπο ανέβηκε με επιτυχία",
          "IMAGE_UPLOAD_ERROR": "Το λογότυπο διαγράφηκε με επιτυχία",
          "IMAGE_DELETE_ERROR": "Σφάλμα κατά τη διαγραφή του λογότυπου"
        },
        "NAME": {
          "LABEL": "Όνομα",
          "PLACEHOLDER": "Όνομα πύλης",
          "HELP_TEXT": "Το όνομα θα χρησιμοποιηθεί στο κοινό που βλέπει την πύλη εσωτερικά.",
          "ERROR": "Απαιτείται όνομα"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug Πύλης για τα urls",
          "ERROR": "Το Slug είναι απαραίτητο"
        },
        "DOMAIN": {
          "LABEL": "Προσαρμοσμένο Domain",
          "PLACEHOLDER": "Προσαρμοσμένος τομέας πύλης",
          "HELP_TEXT": "Προσθέστε μόνο αν θέλετε να χρησιμοποιήσετε προσαρμοσμένο domain για τις πύλες σας. Π.χ.: {exampleURL}",
          "ERROR": "Εισάγετε ένα έγκυρο URL τομέα"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Σύνδεσμος Αρχικής Σελίδας",
          "PLACEHOLDER": "Σύνδεσμος αρχικής σελίδας πύλης",
          "HELP_TEXT": "Ο σύνδεσμος που χρησιμοποιείται για την επιστροφή από την πύλη στην αρχική σελίδα. Π.χ.: {exampleURL}",
          "ERROR": "Εισάγετε μια έγκυρη διεύθυνση URL της αρχικής σελίδας"
        },
        "THEME_COLOR": {
          "LABEL": "Χρώμα θέματος πύλης",
          "HELP_TEXT": "Αυτό το χρώμα θα εμφανίζεται ως το χρώμα θέματος της πύλης."
        },
        "PAGE_TITLE": {
          "LABEL": "Τίτλος Σελίδας",
          "PLACEHOLDER": "Τίτλος σελίδας πύλης",
          "HELP_TEXT": "Ο τίτλος της σελίδας θα χρησιμοποιηθεί στην πύλη που βλέπει το κοινό.",
          "ERROR": "Ο τίτλος είναι απαραίτητος"
        },
        "HEADER_TEXT": {
          "LABEL": "Κείμενο Κεφαλίδας",
          "PLACEHOLDER": "Κείμενο κεφαλίδας πύλης",
          "HELP_TEXT": "Το κείμενο κεφαλίδας πύλης θα χρησιμοποιηθεί στο κοινό που βλέπει πύλη.",
          "ERROR": "Απαιτείται κείμενο κεφαλίδας πύλης"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Η πύλη δημιουργήθηκε με επιτυχία.",
          "ERROR_MESSAGE_FOR_BASIC": "Δεν ήταν δυνατή η δημιουργία της πύλης. Δοκιμάστε ξανά.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Η πύλη ενημερώθηκε με επιτυχία.",
          "ERROR_MESSAGE_FOR_UPDATE": "Δεν ήταν δυνατή η ενημέρωση της πύλης. Δοκιμάστε ξανά."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Προσθέστε μια νέα γλώσσα",
        "SUB_TITLE": "Προσθέτει μια νέα γλώσσα στη διαθέσιμη λίστα μεταφράσεών σας.",
        "PORTAL": "Πύλη",
        "LOCALE": {
          "LABEL": "Γλώσσα",
          "PLACEHOLDER": "Επιλέξτε μια γλώσσα",
          "ERROR": "Η γλώσσα απαιτείται"
        },
        "BUTTONS": {
          "CREATE": "Δημιουργία γλώσσας",
          "CANCEL": "Άκυρο"
        },
        "API": {
          "SUCCESS_MESSAGE": "Η γλώσσα προστέθηκε επιτυχώς",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η προσθήκη γλώσσας. Δοκιμάστε ξανά."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Η προεπιλεγμένη γλώσσα ενημερώθηκε επιτυχώς",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η ενημέρωση της προεπιλεγμένης γλώσσας. Δοκιμάστε ξανά."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Η γλώσσα αφαιρέθηκε επιτυχώς από την πύλη",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η αφαίρεση γλώσσας από την πύλη. Δοκιμάστε ξανά."
        }
      }
    },
    "TABLE": {
      "404": "Δεν υπάρχουν άρθρα που να ταιριάζουν στην αναζήτησή σας 🔍",
      "LOADING_MESSAGE": "Φόρτωση άρθρων...",
      "NO_ARTICLES": "Δεν υπάρχουν διαθέσιμα άρθρα",
      "HEADERS": {
        "TITLE": "Τίτλος",
        "CATEGORY": "Κατηγορία",
        "READ_COUNT": "Προβολές",
        "STATUS": "Κατάσταση",
        "LAST_EDITED": "Τελευταία επεξεργασία"
      },
      "COLUMNS": {
        "BY": "από",
        "AUTHOR_NOT_AVAILABLE": "Ο συγγραφέας δεν είναι διαθέσιμος"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Φόρτωση άρθρου...",
      "TITLE_PLACEHOLDER": "Ο τίτλος του άρθρου εμφανίζεται εδώ",
      "CONTENT_PLACEHOLDER": "Γράψτε το άρθρο σας εδώ",
      "API": {
        "ERROR": "Σφάλμα κατά την αποθήκευση άρθρου"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Σφάλμα κατά τη δημοσίευση του άρθρου",
        "SUCCESS": "Το Άρθρο δημοσιεύθηκε με επιτυχία"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Σφάλμα κατά την αρχειοθέτηση άρθρου",
        "SUCCESS": "Το άρθρο αρχειοθετήθηκε επιτυχώς"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Σφάλμα κατά την αποθήκευση του άρθρου ως Draft",
        "SUCCESS": "Το άρθρο αποθηκεύτηκε επιτυχώς ως Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Επιβεβαίωση Διαγραφής",
          "MESSAGE": "Είστε βέβαιοι να διαγράψετε το άρθρο;",
          "YES": "Ναι, Διέγραψε το",
          "NO": "Όχι, Κράτησε τον/την"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Το άρθρο διαγράφηκε επιτυχώς",
        "ERROR_MESSAGE": "Σφάλμα κατά τη διαγραφή άρθρου"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Παρακαλώ προσθέστε την επικεφαλίδα και το περιεχόμενο του άρθρου για να μπορείτε να ενημερώσετε τις ρυθμίσεις"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Αναζήτηση άρθρων"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Δημιουργία κατηγορίας",
        "SUB_TITLE": "Η κατηγορία θα χρησιμοποιηθεί στην πύλη που βλέπει το κοινό για την κατηγοριοποίηση των άρθρων.",
        "PORTAL": "Πύλη",
        "LOCALE": "Γλώσσα",
        "NAME": {
          "LABEL": "Όνομα",
          "PLACEHOLDER": "Όνομα κατηγορίας",
          "HELP_TEXT": "Το όνομα και το εικονίδιο της κατηγορίας θα χρησιμοποιούνται στην πύλη που βλέπει το κοινό για την κατηγοριοποίηση των άρθρων.",
          "ERROR": "Απαιτείται όνομα"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug κατηγορίας για urls",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Το Slug είναι απαραίτητο"
        },
        "DESCRIPTION": {
          "LABEL": "Περιγραφή",
          "PLACEHOLDER": "Δώστε μια σύντομη περιγραφή της κατηγορίας.",
          "ERROR": "Η περιγραφή απαιτείται"
        },
        "BUTTONS": {
          "CREATE": "Δημιουργία κατηγορίας",
          "CANCEL": "Άκυρο"
        },
        "API": {
          "SUCCESS_MESSAGE": "Η κατηγορία δημιουργήθηκε με επιτυχία",
          "ERROR_MESSAGE": "Αδυναμία δημιουργίας κατηγορίας"
        }
      },
      "EDIT": {
        "TITLE": "Επεξεργασία κατηγορίας",
        "SUB_TITLE": "Η επεξεργασία μιας κατηγορίας θα ενημερώσει την κατηγορία στην πύλη που βλέπει το κοινό.",
        "PORTAL": "Πύλη",
        "LOCALE": "Γλώσσα",
        "NAME": {
          "LABEL": "Όνομα",
          "PLACEHOLDER": "Όνομα κατηγορίας",
          "HELP_TEXT": "Το όνομα και το εικονίδιο της κατηγορίας θα χρησιμοποιούνται στην πύλη που βλέπει το κοινό για την κατηγοριοποίηση των άρθρων.",
          "ERROR": "Απαιτείται όνομα"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug κατηγορίας για urls",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Το Slug είναι απαραίτητο"
        },
        "DESCRIPTION": {
          "LABEL": "Περιγραφή",
          "PLACEHOLDER": "Δώστε μια σύντομη περιγραφή της κατηγορίας.",
          "ERROR": "Η περιγραφή απαιτείται"
        },
        "BUTTONS": {
          "CREATE": "Επεξεργασία κατηγορίας",
          "CANCEL": "Άκυρο"
        },
        "API": {
          "SUCCESS_MESSAGE": "Η κατηγορία ενημερώθηκε επιτυχώς",
          "ERROR_MESSAGE": "Αδύνατη η ενημέρωση της κατηγορίας"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Η κατηγορία διαγράφηκε επιτυχώς",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η διαγραφή κατηγορίας"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Αναζήτηση άρθρων",
      "PLACEHOLDER": "Αναζήτηση άρθρων",
      "NO_RESULT": "Δεν βρέθηκαν άρθρα",
      "SEARCHING": "Αναζήτηση...",
      "SEARCH_BUTTON": "Αναζήτηση",
      "INSERT_ARTICLE": "Εισαγωγή συνδέσμου",
      "IFRAME_ERROR": "Το URL είναι κενό ή μη έγκυρο. Δεν είναι δυνατή η εμφάνιση περιεχομένου.",
      "OPEN_ARTICLE_SEARCH": "Εισαγωγή άρθρου από το Κέντρο Βοήθειας",
      "SUCCESS_ARTICLE_INSERTED": "Το άρθρο εισήχθη με επιτυχία",
      "PREVIEW_LINK": "Προεπισκόπηση άρθρου",
      "CANCEL": "Κλείσιμο",
      "BACK": "Πίσω",
      "BACK_RESULTS": "Πίσω στα αποτελέσματα"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Κέντρο Βοήθειας",
      "DESCRIPTION": "Δημιουργήστε φιλικές προς τον χρήστη πύλες αυτοεξυπηρέτησης. Βοηθήστε τους χρήστες σας να έχουν πρόσβαση στα άρθρα και να λαμβάνουν υποστήριξη 24/7. Αναβαθμίστε τη συνδρομή σας για να ενεργοποιήσετε αυτή τη λειτουργία.",
      "SELF_HOSTED_DESCRIPTION": "Δημιουργήστε φιλικές προς τον χρήστη πύλες αυτοεξυπηρέτησης. Βοηθήστε τους χρήστες σας να έχουν πρόσβαση στα άρθρα και να λαμβάνουν υποστήριξη 24/7. Επικοινωνήστε με τον διαχειριστή σας για να ενεργοποιήσετε αυτή τη λειτουργία.",
      "BUTTON": {
        "LEARN_MORE": "Μάθετε περισσότερα",
        "UPGRADE": "Αναβάθμιση"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Πολλαπλές πύλες",
          "DESCRIPTION": "Δημιουργήστε πολλαπλές πύλες κέντρου βοήθειας για διαφορετικά προϊόντα χρησιμοποιώντας τον ίδιο λογαριασμό."
        },
        "LOCALES": {
          "TITLE": "Πλήρης υποστήριξη γλωσσών",
          "DESCRIPTION": "Μεταφράστε την πύλη στη γλώσσα σας. Υποστηρίζουμε όλες τις γλώσσες και επιτρέπουμε μεταφράσεις για κάθε άρθρο."
        },
        "SEO": {
          "TITLE": "Σχεδίαση φιλική προς το SEO",
          "DESCRIPTION": "Προσαρμόστε τα meta tags σας για να βελτιώσετε την προβολή σας στις μηχανές αναζήτησης με τις σελίδες μας φιλικές προς το SEO."
        },
        "API": {
          "TITLE": "Πλήρης υποστήριξη API",
          "DESCRIPTION": "Χρησιμοποιήστε την πύλη ως headless CMS με πλαίσια front-end τρίτων μέσω των API μας."
        }
      }
    },
    "LOADING": "Φόρτωση...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} προβολή | {count} προβολές",
          "DROPDOWN_MENU": {
            "PUBLISH": "Δημοσίευση",
            "DRAFT": "Draft",
            "ARCHIVE": "Αρχειοθέτηση",
            "DELETE": "Διαγραφή"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Δημοσιευμένο",
            "ARCHIVED": "Αρχειοθετημένο"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Χωρίς κατηγορία"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Όλα τα άρθρα",
          "MINE": "Δικές μου",
          "DRAFT": "Draft",
          "PUBLISHED": "Δημοσιευμένο",
          "ARCHIVED": "Αρχειοθετημένο"
        },
        "CATEGORY": {
          "ALL": "Όλες οι κατηγορίες"
        },
        "LOCALE": {
          "ALL": "Όλες οι γλώσσες"
        },
        "NEW_ARTICLE": "Νέο άρθρο"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Γράψτε ένα άρθρο",
          "SUBTITLE": "Γράψτε ένα εμπλουτισμένο άρθρο, ας ξεκινήσουμε!",
          "BUTTON_LABEL": "Νέο άρθρο"
        },
        "MINE": {
          "TITLE": "Δεν έχετε γράψει ακόμα κανένα άρθρο εδώ",
          "SUBTITLE": "Όλα τα άρθρα που έχετε γράψει εμφανίζονται εδώ για γρήγορη πρόσβαση."
        },
        "DRAFT": {
          "TITLE": "Δεν υπάρχουν άρθρα σε Draft",
          "SUBTITLE": "Τα άρθρα σε Draft θα εμφανίζονται εδώ"
        },
        "PUBLISHED": {
          "TITLE": "Δεν υπάρχουν δημοσιευμένα άρθρα",
          "SUBTITLE": "Τα δημοσιευμένα άρθρα θα εμφανίζονται εδώ"
        },
        "ARCHIVED": {
          "TITLE": "Δεν υπάρχουν άρθρα στο αρχείο",
          "SUBTITLE": "Τα αρχειοθετημένα άρθρα δεν εμφανίζονται στην πύλη· μπορείτε να τα χρησιμοποιήσετε για να επισημάνετε παρωχημένες ή ξεπερασμένες σελίδες"
        },
        "CATEGORY": {
          "TITLE": "Δεν υπάρχουν άρθρα σε αυτή την κατηγορία",
          "SUBTITLE": "Τα άρθρα αυτής της κατηγορίας θα εμφανίζονται εδώ"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Νέα κατηγορία",
        "EDIT_CATEGORY": "Επεξεργασία κατηγορίας",
        "CATEGORIES_COUNT": "{n} κατηγορία | {n} κατηγορίες",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Κατηγορίες ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} άρθρα) | {categoryName} ({categoryCount} άρθρο)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Δεν βρέθηκαν κατηγορίες",
        "SUBTITLE": "Οι κατηγορίες θα εμφανίζονται εδώ. Μπορείτε να προσθέσετε μια κατηγορία κάνοντας κλικ στο κουμπί «Νέα κατηγορία»."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} άρθρο | {count} άρθρα",
        "EXPAND": "Εμφάνιση υποκατηγοριών",
        "COLLAPSE": "Απόκρυψη υποκατηγοριών",
        "MENU": {
          "NEW_ARTICLE": "Νέο άρθρο",
          "ADD_SUBCATEGORY": "Προσθήκη υποκατηγορίας",
          "EDIT": "Επεξεργασία",
          "DELETE": "Διαγραφή"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Η κατηγορία δημιουργήθηκε με επιτυχία",
            "ERROR_MESSAGE": "Αδυναμία δημιουργίας κατηγορίας"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Η κατηγορία ενημερώθηκε επιτυχώς",
            "ERROR_MESSAGE": "Αδύνατη η ενημέρωση της κατηγορίας"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Η κατηγορία διαγράφηκε επιτυχώς",
            "ERROR_MESSAGE": "Δεν είναι δυνατή η διαγραφή κατηγορίας"
          },
          "CONFIRM": {
            "TITLE": "Διαγραφή κατηγορίας",
            "DESCRIPTION": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή την κατηγορία; Τα άρθρα της θα μείνουν χωρίς κατηγορία.",
            "DESCRIPTION_WITH_CHILDREN": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή την κατηγορία; Τα άρθρα της θα μείνουν χωρίς κατηγορία και η {count} υποκατηγορία της θα μετακινηθεί στο ανώτερο επίπεδο. | Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή την κατηγορία; Τα άρθρα της θα μείνουν χωρίς κατηγορία και οι {count} υποκατηγορίες της θα μετακινηθούν στο ανώτερο επίπεδο.",
            "CONFIRM": "Διαγραφή"
          }
        },
        "HEADER": {
          "CREATE": "Δημιουργία κατηγορίας",
          "EDIT": "Επεξεργασία κατηγορίας",
          "DESCRIPTION": "Η επεξεργασία μιας κατηγορίας θα ενημερώσει την κατηγορία στην πύλη που βλέπει το κοινό.",
          "PORTAL": "Πύλη",
          "LOCALE": "Γλώσσα"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Όνομα",
            "PLACEHOLDER": "Όνομα κατηγορίας",
            "ERROR": "Απαιτείται όνομα"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug κατηγορίας για urls",
            "ERROR": "Το Slug είναι απαραίτητο",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Περιγραφή",
            "PLACEHOLDER": "Δώστε μια σύντομη περιγραφή της κατηγορίας.",
            "ERROR": "Η περιγραφή απαιτείται"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Γονική κατηγορία",
            "PLACEHOLDER": "Επιλέξτε γονική κατηγορία",
            "NONE": "Καμία (ανώτατο επίπεδο)"
          }
        },
        "BUTTONS": {
          "CREATE": "Δημιουργία",
          "EDIT": "Ενημέρωση",
          "CANCEL": "Άκυρο"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Δεν υπάρχουν διαθέσιμες γλώσσες | {n} γλώσσα | {n} γλώσσες",
      "NEW_LOCALE_BUTTON_TEXT": "Νέα γλώσσα",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} άρθρο | {count} άρθρα",
        "CATEGORIES_COUNT": "{count} κατηγορία | {count} κατηγορίες",
        "DEFAULT": "Προεπιλογή",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Ορισμός ως προεπιλογή",
          "DELETE": "Διαγραφή"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Προσθέστε μια νέα γλώσσα",
        "DESCRIPTION": "Επιλέξτε τη γλώσσα στην οποία θα γραφτεί αυτό το άρθρο. Θα προστεθεί στη λίστα μεταφράσεών σας και μπορείτε να προσθέσετε κι άλλες αργότερα.",
        "COMBOBOX": {
          "PLACEHOLDER": "Επιλέξτε γλώσσα..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Η γλώσσα προστέθηκε επιτυχώς",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η προσθήκη γλώσσας. Δοκιμάστε ξανά."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Αποθηκεύεται...",
          "SAVED": "Αποθηκεύτηκε"
        },
        "PREVIEW": "Προεπισκόπηση",
        "PUBLISH": "Δημοσίευση",
        "DRAFT": "Draft",
        "ARCHIVE": "Αρχειοθέτηση",
        "BACK_TO_ARTICLES": "Πίσω στα άρθρα"
      },
      "DRAFT": {
        "PENDING_LABEL": "Μη δημοσιευμένες αλλαγές",
        "PROMOTE": "Δημοσίευση αλλαγών",
        "DISCARD": "Απόρριψη αλλαγών",
        "PROMOTE_SUCCESS": "Οι αλλαγές Draft δημοσιεύτηκαν στο ενεργό άρθρο",
        "PROMOTE_ERROR": "Δεν ήταν δυνατή η δημοσίευση των αλλαγών Draft",
        "DISCARD_SUCCESS": "Οι αλλαγές Draft απορρίφθηκαν",
        "DISCARD_ERROR": "Δεν ήταν δυνατή η απόρριψη των αλλαγών Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Ιστορικό εκδόσεων",
        "TITLE": "Ιστορικό εκδόσεων",
        "BACK": "Πίσω στο άρθρο",
        "LOADING": "Φόρτωση εκδόσεων...",
        "EMPTY": "Δεν υπάρχουν ακόμα εκδόσεις. Οι επεξεργασίες σε αυτό το άρθρο θα εμφανίζονται εδώ.",
        "EMPTY_CONTENT": "Αυτή η έκδοση δεν έχει περιεχόμενο.",
        "CURRENT_BADGE": "Τρέχουσα",
        "RESTORED_BADGE": "Επαναφέρθηκε",
        "AUTOMATED_USER": "Αυτόματη ενημέρωση",
        "RESTORE": "Επαναφορά αυτής της έκδοσης",
        "RESTORE_DIALOG": {
          "TITLE": "Επαναφορά αυτής της έκδοσης;",
          "DESCRIPTION": "Το άρθρο θα επιστρέψει στη διατύπωση αυτής της έκδοσης. Δεν χάνεται τίποτα — το τρέχον κείμενο παραμένει στο ιστορικό και ένα δημοσιευμένο άρθρο θα συνεχίσει να εμφανίζει την ενεργή έκδοση μέχρι να δημοσιεύσετε την αλλαγή.",
          "CONFIRM": "Επαναφορά"
        },
        "RESTORE_SUCCESS": "Η έκδοση επαναφέρθηκε",
        "RESTORE_ERROR": "Δεν ήταν δυνατή η επαναφορά αυτής της έκδοσης",
        "FETCH_ERROR": "Δεν ήταν δυνατή η φόρτωση του ιστορικού εκδόσεων"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Περισσότερες ιδιότητες",
        "TRANSLATE": "Μετάφραση",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Χωρίς κατηγορία",
        "EDITOR_PLACEHOLDER": "Γράψτε κάτι...",
        "HTML_EMBED": {
          "TITLE": "Εισαγωγή προσαρμοσμένου HTML",
          "DESCRIPTION": "Επικολλήστε ακατέργαστο HTML, όπως ένα iframe, ένα embed ή ένα απόσπασμα widget. Θα εμφανιστεί ως έχει στο δημοσιευμένο άρθρο.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Εισαγωγή"
        },
        "PRIMARY_CATEGORY": "Κύρια κατηγορία"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Ιδιότητες άρθρου",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta περιγραφή",
        "META_DESCRIPTION_PLACEHOLDER": "Προσθήκη meta περιγραφής",
        "META_TITLE": "Μετα-τίτλος",
        "META_TITLE_PLACEHOLDER": "Προσθήκη meta τίτλου",
        "META_TAGS": "Meta tags",
        "META_TAGS_PLACEHOLDER": "Προσθήκη meta tags",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Γλωσσικές εκδοχές",
        "LANGUAGE_MUTATIONS_EMPTY": "Δεν υπάρχουν συνδεδεμένα άρθρα",
        "ADD_MUTATION": "Προσθήκη",
        "REMOVE_MUTATION": "Αφαίρεση"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Σύνδεση γλωσσικών εκδοχών",
        "SEARCH_PLACEHOLDER": "Αναζήτηση άρθρων κατά τίτλο",
        "EMPTY": "Δεν βρέθηκαν άρθρα",
        "CANCEL": "Ακύρωση",
        "ADD_SELECTED": "Προσθήκη επιλεγμένων",
        "SUCCESS": "Οι εκδοχές ενημερώθηκαν",
        "ERROR": "Αποτυχία ενημέρωσης εκδοχών"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Μετάφραση άρθρου",
        "DESCRIPTION": "Επιλέξτε τις γλώσσες στις οποίες θέλετε να μεταφράσετε αυτό το άρθρο.",
        "EMPTY": "Δεν υπάρχουν διαθέσιμες άλλες γλώσσες.",
        "CONNECTED_BADGE": "Μεταφρασμένο",
        "CANCEL": "Ακύρωση",
        "TRANSLATE": "Μετάφραση",
        "SUCCESS": "Η μετάφραση θα ξεκινήσει σύντομα. Τα μεταφρασμένα άρθρα θα εμφανιστούν σύντομα ως γλωσσικές εκδοχές.",
        "ERROR": "Αποτυχία έναρξης της μετάφρασης"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Σφάλμα κατά την αποθήκευση άρθρου"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Νέα πύλη",
      "PORTALS": "Πύλες",
      "CREATE_PORTAL": "Δημιουργήστε και διαχειριστείτε πολλαπλές πύλες",
      "ARTICLES": "άρθρα",
      "DOMAIN": "domain",
      "PORTAL_NAME": "Όνομα πύλης"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Δημιουργία νέας πύλης",
      "DESCRIPTION": "Δώστε ένα όνομα στην πύλη σας και δημιουργήστε ένα φιλικό προς τον χρήστη slug για το URL. Μπορείτε να τα τροποποιήσετε και τα δύο αργότερα από τις ρυθμίσεις.",
      "CONFIRM_BUTTON_LABEL": "Δημιουργία",
      "NAME": {
        "LABEL": "Όνομα",
        "PLACEHOLDER": "Οδηγός χρήσης",
        "MESSAGE": "Επιλέξτε ένα όνομα για την πύλη σας.",
        "ERROR": "Απαιτείται όνομα"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Το Slug είναι απαραίτητο",
        "FORMAT_ERROR": "Χρησιμοποιήστε μόνο γράμματα, αριθμούς και παύλες, για παράδειγμα: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Λογότυπο",
          "IMAGE_UPLOAD_ERROR": "Δεν ήταν δυνατή η μεταφόρτωση της εικόνας! Δοκιμάστε ξανά",
          "IMAGE_UPLOAD_SUCCESS": "Η εικόνα προστέθηκε με επιτυχία. Κάντε κλικ στην αποθήκευση αλλαγών για να αποθηκεύσετε το λογότυπο",
          "IMAGE_DELETE_SUCCESS": "Το λογότυπο διαγράφηκε με επιτυχία",
          "IMAGE_DELETE_ERROR": "Δεν είναι δυνατή η διαγραφή του λογότυπου",
          "IMAGE_UPLOAD_SIZE_ERROR": "Το μέγεθος της εικόνας πρέπει να είναι μικρότερο από {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Όνομα",
          "PLACEHOLDER": "Όνομα πύλης",
          "ERROR": "Απαιτείται όνομα"
        },
        "HEADER_TEXT": {
          "LABEL": "Κείμενο κεφαλίδας",
          "PLACEHOLDER": "Κείμενο κεφαλίδας πύλης"
        },
        "PAGE_TITLE": {
          "LABEL": "Τίτλος σελίδας",
          "PLACEHOLDER": "Τίτλος σελίδας πύλης"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Σύνδεσμος αρχικής σελίδας",
          "PLACEHOLDER": "Σύνδεσμος αρχικής σελίδας πύλης",
          "ERROR": "Μη έγκυρο URL. Ο σύνδεσμος αρχικής σελίδας πρέπει να ξεκινά με 'http://' ή 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug πύλης"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget ζωντανής συνομιλίας",
          "PLACEHOLDER": "Επιλέξτε widget ζωντανής συνομιλίας",
          "HELP_TEXT": "Επιλέξτε ένα widget ζωντανής συνομιλίας που θα εμφανίζεται στο κέντρο βοήθειάς σας"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Δημόσια προσβάσιμο",
          "HELP_TEXT": "Κάντε την πύλη προσβάσιμη σε όποιον έχει τον σύνδεσμο.",
          "OPTIONS": {
            "PUBLIC": "Ναι",
            "PRIVATE": "Όχι"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Προορισμός συνδέσμου",
          "HELP_TEXT": "Επιλέξτε αν οι σύνδεσμοι μέσα στα άρθρα ανοίγουν στο τρέχον παράθυρο ή σε νέο.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Τρέχον παράθυρο",
            "NEW_WINDOW": "Νέο παράθυρο"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Προεπιλεγμένο μέγεθος εικόνας",
          "HELP_TEXT": "Το μέγεθος που εφαρμόζεται σε κάθε εικόνα που εισάγετε σε ένα άρθρο. Επιλέξτε Original για να εισάγετε τις εικόνες στο αρχικό τους μέγεθος και να επιλέγετε μέγεθος για κάθε εικόνα ξεχωριστά."
        },
        "BRAND_COLOR": {
          "LABEL": "Χρώμα μάρκας"
        },
        "CUSTOM_HTML": {
          "LABEL": "Προσαρμοσμένο HTML",
          "PLACEHOLDER": "<!-- Επικολλήστε εδώ το απόσπασμα analytics ή παρακολούθησης -->",
          "HELP_TEXT": "Εισάγεται στην αρχή της ετικέτας <body> σε κάθε σελίδα του Κέντρου Βοήθειας. Χρησιμοποιήστε το για Google Analytics, Google Tag Manager ή οποιοδήποτε άλλο απόσπασμα παρακολούθησης. Ο κώδικας αποδίδεται ακριβώς όπως έχει εισαχθεί και δεν επικυρώνεται."
        },
        "SAVE_CHANGES": "Αποθήκευση αλλαγών"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Προσαρμοσμένο Domain",
          "LABEL": "Προσαρμοσμένο Domain:",
          "DESCRIPTION": "Μπορείτε να φιλοξενήσετε την πύλη σας σε προσαρμοσμένο domain. Για παράδειγμα, αν ο ιστότοπός σας είναι yourdomain.com και θέλετε η πύλη σας να είναι διαθέσιμη στο docs.yourdomain.com, απλώς εισαγάγετε αυτό στο πεδίο.",
          "PLACEHOLDER": "Προσαρμοσμένος τομέας πύλης",
          "EDIT_BUTTON": "Επεξεργασία προσαρμοσμένου domain",
          "ADD_BUTTON": "Προσθήκη προσαρμοσμένου domain",
          "DIALOG": {
            "ADD_HEADER": "Προσθήκη προσαρμοσμένου domain",
            "EDIT_HEADER": "Επεξεργασία προσαρμοσμένου domain",
            "ADD_CONFIRM_BUTTON_LABEL": "Προσθήκη domain",
            "EDIT_CONFIRM_BUTTON_LABEL": "Ενημέρωση domain",
            "LABEL": "Προσαρμοσμένο Domain",
            "PLACEHOLDER": "Προσαρμοσμένος τομέας πύλης",
            "ERROR": "Απαιτείται προσαρμοσμένο domain"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Ρύθμιση DNS",
            "DESCRIPTION": "Συνδεθείτε στον λογαριασμό που έχετε με τον πάροχο DNS σας και προσθέστε την παρακάτω εγγραφή CNAME για το subdomain σας.",
            "HELP_TEXT": "Μόλις ολοκληρωθεί αυτό, μπορείτε να επικοινωνήσετε με την υποστήριξή μας για να ζητήσετε το αυτόματα δημιουργημένο πιστοποιητικό SSL.",
            "CONFIRM_BUTTON_LABEL": "Το κατάλαβα!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Διαγραφή {portalName}",
          "HEADER": "Διαγραφή πύλης",
          "DESCRIPTION": "Οριστική διαγραφή αυτής της πύλης. Η ενέργεια αυτή δεν μπορεί να αναιρεθεί",
          "DIALOG": {
            "HEADER": "Είστε βέβαιοι ότι θέλετε να διαγράψετε το {portalName};",
            "DESCRIPTION": "Αυτή είναι μια μόνιμη ενέργεια που δεν μπορεί να αναιρεθεί.",
            "CONFIRM_BUTTON_LABEL": "Διαγραφή"
          }
        },
        "EDIT_CONFIGURATION": "Επεξεργασία ρυθμίσεων"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Η πύλη δημιουργήθηκε με επιτυχία",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η δημιουργία πύλης"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Η πύλη ενημερώθηκε με επιτυχία",
          "ERROR_MESSAGE": "Δεν είναι δυνατή η ενημέρωση πύλης"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Συνημμένα",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Προσθήκη αρχείου",
      "DROP_HERE": "Σύρετε και αφήστε αρχεία εδώ",
      "COPY_LINK": "Αντιγραφή συνδέσμου",
      "LINK_COPIED": "Ο σύνδεσμος αντιγράφηκε στο πρόχειρο",
      "COPY_FAILED": "Αποτυχία αντιγραφής συνδέσμου",
      "DELETE": "Διαγραφή",
      "CANCEL": "Ακύρωση",
      "QUEUED": "Σε αναμονή",
      "UPLOADING": "Ανέβασμα",
      "UPLOAD_FAILED": "Αποτυχία μεταφόρτωσης αρχείου",
      "FILE_TOO_LARGE": "Το αρχείο υπερβαίνει το όριο μεγέθους των 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Λεξικό μεταφράσεων",
        "DESCRIPTION": "Οι όροι που ορίζονται εδώ προστίθενται στο prompt μετάφρασης AI, ώστε να μεταφράζονται πάντα με τον ίδιο τρόπο. Ο βασικός όρος είναι γραμμένος στα {locale}."
      },
      "NEW_TERM": "Νέος όρος",
      "EMPTY_STATE": {
        "TITLE": "Δεν υπάρχουν όροι λεξικού ακόμα",
        "SUBTITLE": "Προσθέστε έναν όρο και τη μετάφρασή του για κάθε γλώσσα. Όταν μεταφράζεται ένα άρθρο, αυτοί οι όροι επιβάλλονται ώστε η ορολογία του προϊόντος σας να παραμένει συνεπής."
      },
      "LIST": {
        "TERM": "Όρος",
        "TRANSLATIONS": "Μεταφράσεις",
        "ACTIONS": "Ενέργειες"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Προσθήκη όρου",
          "EDIT": "Επεξεργασία όρου",
          "DESCRIPTION": "Ο παρακάτω όρος επιβάλλεται κατά την αυτόματη μετάφραση (AI) των άρθρων του κέντρου βοήθειάς σας.",
          "PORTAL": "Πύλη",
          "PRIMARY_LANGUAGE": "Κύρια γλώσσα"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Όρος ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Ο όρος είναι υποχρεωτικός"
          },
          "DESCRIPTION": {
            "LABEL": "Πλαίσιο / σημειώσεις (προαιρετικό)",
            "PLACEHOLDER": "Πότε και πώς χρησιμοποιείται αυτός ο όρος, για να βοηθήσει τον μεταφραστή να αποσαφηνίσει το νόημα."
          },
          "TRANSLATIONS": "Μεταφράσεις",
          "TRANSLATION_PLACEHOLDER": "Αφήστε το κενό για να το μεταφράσει ελεύθερα το AI",
          "AUTO_TRANSLATE": {
            "BUTTON": "Αυτόματη μετάφραση όλων",
            "CONFIRM": "Μετάφραση σε {count} γλώσσες με AI;",
            "CONFIRM_BUTTON": "Μετάφραση",
            "CANCEL": "Ακύρωση",
            "SUCCESS": "Οι μεταφράσεις δημιουργήθηκαν — ελέγξτε τις και αποθηκεύστε",
            "ERROR": "Δεν ήταν δυνατή η αυτόματη μετάφραση, δοκιμάστε ξανά"
          }
        },
        "BUTTONS": {
          "CREATE": "Προσθήκη όρου",
          "EDIT": "Αποθήκευση",
          "CANCEL": "Ακύρωση"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Ο όρος προστέθηκε με επιτυχία",
            "ERROR_MESSAGE": "Δεν ήταν δυνατή η προσθήκη του όρου, δοκιμάστε ξανά"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Ο όρος ενημερώθηκε με επιτυχία",
            "ERROR_MESSAGE": "Δεν ήταν δυνατή η ενημέρωση του όρου, δοκιμάστε ξανά"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Διαγραφή όρου",
          "DESCRIPTION": "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτόν τον όρο; Δεν θα επιβάλλεται πλέον κατά τη μετάφραση.",
          "CONFIRM": "Διαγραφή"
        },
        "API": {
          "SUCCESS_MESSAGE": "Ο όρος διαγράφηκε με επιτυχία",
          "ERROR_MESSAGE": "Δεν ήταν δυνατή η διαγραφή του όρου, δοκιμάστε ξανά"
        }
      }
    }
  }
}
